import { LocDefs, LocMap } from '@cm/core/localization';
import { pathStart, sharedProperties } from '../../models/score-report-delay-locs';

export type SPSettingsScoreReportDelayFormLocNames =
	| 'SPSettingsScoreReportDelayFormJurisdictionField'
	| 'SPSettingsScoreReportDelayFormJurisdictionFieldRequired'
	| 'SPSettingsScoreReportDelayFormJurisdictionFieldNoMatch'
	| 'SPSettingsScoreReportDelayFormDelayField'
	| 'SPSettingsScoreReportDelayFormDelayFieldRequired'
	| 'SPSettingsScoreReportDelayFormDelayFieldMin'
	| 'SPSettingsScoreReportDelayFormDelayFieldInvalid';

export const spSettingsScoreReportDelayFormLocs: LocDefs<SPSettingsScoreReportDelayFormLocNames> = {
	SPSettingsScoreReportDelayFormJurisdictionField: {
		defaultValue: 'Jurisdiction',
		description: 'Label for the jurisdiction field.',
		displayPath: `${pathStart}Delay Settings Form Jurisdiction Field`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayFormJurisdictionFieldRequired: {
		defaultValue: 'Jurisdiction is required',
		description: 'Error message that indicates the jurisdiction field is required.',
		displayPath: `${pathStart}Delay Settings Form|Jurisdiction Field Required`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayFormJurisdictionFieldNoMatch: {
		defaultValue: 'Jurisdiction is invalid',
		description: 'Error message that indicates the jurisdiction field is invalid.',
		displayPath: `${pathStart}Delay Settings Form|Jurisdiction Field No Match`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayFormDelayField: {
		defaultValue: 'Delay',
		description: 'Label for the delay field.',
		displayPath: `${pathStart}Default Settings|Delay Field`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayFormDelayFieldRequired: {
		defaultValue: 'Delay is required',
		description: 'Error message that indicates the delay field is required.',
		displayPath: `${pathStart}Default Settings|Delay Field Required`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayFormDelayFieldMin: {
		defaultValue: 'Delay must be greater than 0',
		description: 'Error message that indicates the delay field must be greater than 0.',
		displayPath: `${pathStart}Default Settings|Delay Field Min`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayFormDelayFieldInvalid: {
		defaultValue: 'Delay must be a number',
		description: 'Error message that indicates the delay field must be a number.',
		displayPath: `${pathStart}Default Settings|Delay Field Invalid`,
		displayType: 'Error',
		...sharedProperties,
	},
};

export type SPSettingsScoreReportDelayFormLocType = LocMap<SPSettingsScoreReportDelayFormLocNames>;
